import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapse"]

  connect() {
    this.clickOutside = this.clickOutside.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const isExpanded = this.collapseTarget.classList.contains("show")
    
    if (isExpanded) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.collapseTarget.classList.add("show")
    const button = this.element.querySelector('[aria-expanded]')
    if (button) {
      button.setAttribute('aria-expanded', 'true')
    }
    document.addEventListener('click', this.clickOutside, true)
  }

  close() {
    this.collapseTarget.classList.remove("show")
    const button = this.element.querySelector('[aria-expanded]')
    if (button) {
      button.setAttribute('aria-expanded', 'false')
    }
    document.removeEventListener('click', this.clickOutside, true)
    
    // Close all dropdowns when closing navbar
    this.collapseTarget.querySelectorAll('.dropdown-menu.show').forEach(menu => {
      menu.classList.remove('show')
    })
  }

  clickOutside(event) {
    // Don't close if clicking inside the navbar
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutside, true)
  }
}
